import gql from 'graphql-tag';

const UPDATE_MARKETING_ONLY_NOTE = gql` 
  mutation updateMarketingOnlyNote($input: MarketingOnlyNoteUpdateInput!) {
    updateMarketingOnlyNote(input: $input) {
      message
      code
      data
    }
  }
`;

export default UPDATE_MARKETING_ONLY_NOTE;
